<form [formGroup]="lienDetails">
  @if (uiConfiguration.dischargeDetailsConfiguration?.showDischargeType) {
    <div>
      <div class="flex-container">
        <div class="flex-item form-field">
          <mat-radio-group [formControlName]="'dischargeType'" [attr.aria-label]="'orders.dischargeTypeRadioOption' | transloco">
            <mat-radio-button data-testid="total-discharge-radio-button" class="radio-button" [value]="totalDischarge">{{ 'orders.totalDischarge' | transloco }}</mat-radio-button>
            <mat-radio-button data-testid="agreement-to-discharge-radio-button" class="radio-button" [value]="agreementToDischarge">{{ 'orders.agreementToDischarge' | transloco }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  }

  <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$"
  [order]="order" [isDisabled]="isDisabled" (termFormValueChangedEvent)="handleTermFormValueChanged($event)"></app-term>

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showRegistrationNumber) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.registrationNumber' | transloco }}</mat-label>
          <input matInput data-testid="registration-number-field" [placeholder]="'common.labels.registrationNumber' | transloco"
            [formControlName]="'registrationNumber'" libReplaceCharacter>
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.controls['registrationNumber']"
        [message]="registrationNumberError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.lienDetailsConfiguration?.showFileNumber || uiConfiguration.referenceRegistrationInformationUIConfiguration?.showFileNumber) {
    <div class="flex-container"
      >
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.fileNumber' | transloco }}</mat-label>
          <input matInput data-testid="file-number-field" [placeholder]="'common.labels.fileNumber' | transloco" [formControlName]="'fileNumber'">
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.controls['fileNumber']"
        [message]="fileNumberError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showRIN) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'orders.rin' | transloco }}</mat-label>
          <input matInput data-testid="rin-field" [placeholder]="'orders.rin' | transloco"
            [formControlName]="'rin'">
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.controls['rin']"
        [message]="rinError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showOriginalQCFormTypeID) {
    <div class="flex-container padding-top">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'orders.originalFormType' | transloco }}</mat-label>
        <mat-select data-testid="qc-from-type-dropdown" [formControlName]="'originalQCFormTypeID'">
          @for (qcFormType of qcFormTypes; track qcFormType) {
            <mat-option [value]="qcFormType.value"
              [attr.data-testid]="'form-type-option-' + qcFormType.label.split(' ')[0].toLowerCase()">
              {{qcFormType.label}}
            </mat-option>
          }
        </mat-select>
        <mat-error>{{ 'orders.originalFormTypeIsRequired' | transloco }}</mat-error>
      </mat-form-field>
    </div>
  }

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showOriginalOrderTypeID) {
    <div class="flex-container padding-top">
      <mat-form-field class="flex-item form-field" appearance="outline">
        <mat-label>{{ 'orders.originalRegistrationType' | transloco }}</mat-label>
        <mat-select data-testid="original-order-type-dropdown" [formControlName]="'originalOrderTypeID'">
          @for (orderType of orderTypes; track orderType) {
            <mat-option [value]="orderType.value"
              [attr.data-testid]="'order-type-option-' + orderType.value">
              {{orderType.label}}
            </mat-option>
          }
        </mat-select>
        <mat-error>{{ 'orders.originalRegistrationTypeIsRequired' | transloco }}</mat-error>
      </mat-form-field>
    </div>
  }

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showOriginalRegistrationDate) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="form-field flex-item" appearance="outline">
          <mat-label>{{ 'orders.originalRegistrationDate' | transloco }}</mat-label>
          <input matInput [matDatepicker]="originalRegistrationDate" data-testid="original-registration-date-field" formControlName="originalRegistrationDate"
            [placeholder]="'common.labels.yyyyMmDd' | transloco">
          <mat-datepicker-toggle matSuffix [for]="originalRegistrationDate"></mat-datepicker-toggle>
          <mat-datepicker #originalRegistrationDate></mat-datepicker>
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.get('originalRegistrationDate')!"
        [message]="originalRegistrationDateError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.referenceRegistrationInformationUIConfiguration?.showOriginalExpiryDate && showCurrentExpiryDate) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="form-field flex-item" appearance="outline">
          <mat-label>{{ 'orders.currentExpiryDate' | transloco }}</mat-label>
          <input matInput [matDatepicker]="currentExpiryDate" data-testid="current-expiry-date-field" formControlName="currentExpiryDate"
            [placeholder]="'common.labels.yyyyMmDd' | transloco">
          <mat-datepicker-toggle matSuffix [for]="currentExpiryDate"></mat-datepicker-toggle>
          <mat-datepicker #currentExpiryDate></mat-datepicker>
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.get('currentExpiryDate')!"
        [message]="currentExpiryDateError$"></lib-error-bubble>
      </div>
    </div>
  }
</form>